<template>
  <div class="score-container">
    <!-- <p class="score-show">测评结果</p> -->
    <p style="font-size: 2rem;color: #5e6d82;line-height: 1.5em;margin-bottom: 15px;margin-top: 2rem;">谢谢您的回答！</p>
    <!-- <el-table :data="tableData" border style="width: 100%" :cell-class-name="cellClassName">
      <el-table-column prop="title" label="结果">
      </el-table-column>
      <el-table-column prop="val" label="分值">
        <template slot-scope="scope">
          <template v-if="scope.row.val !== undefined && scope.row.val !== null">
            <span>{{ scope.row.val }}</span>
          </template>
          <template v-else>
            <span>{{ scope.row.chengdu }}</span>
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="chengdu" label="程度">
        <template slot-scope="scope">
          <template v-if="scope.row.val == undefined || scope.row.val == null">
            {{ scope.row.grade.res }}
          </template>
          <template v-else>
            <span>{{ scope.row.chengdu }}</span>
          </template>
        </template>
      </el-table-column>
    </el-table> -->
    <!-- <div class="tag-group margin-top" style="align-self: flex-start;">
      <span class="tag-group__title">程度说明：</span>
      <el-tag color="#2ed573" style="color: #fff;border-color:#2ed573" size="mini">没有</el-tag>
      <el-tag color="#eccc68" style="color: #fff;border-color:#eccc68" size="mini">轻度</el-tag>
      <el-tag color="#ff7f50" style="color: #fff;border-color:#ff7f50" size="mini">中度</el-tag>
      <el-tag color="#ff4757" style="color: #fff;border-color:#ff4757" size="mini">严重</el-tag>
    </div> -->
    <div style="align-self: flex-start;">
      <!-- <p class="tag-group__title" style="line-height: 1.5em;margin-bottom: 15px;margin-top: 2rem;">
        最高预警等级：{{ maxRes }}
      </p> -->
      <!-- <p class="tag-group__title" style="line-height: 1.5em;margin-bottom: 15px;margin-top: 2rem;">
        谢谢您的回答！
      </p> -->
      <!-- <p class="tag-group__title" style="line-height: 1.5em;margin-bottom: 15px;margin-top: 2rem;">
        总答题时长{{ useTimeCn }}
      </p> -->
      <!-- <p class="tag-group__title" style="line-height: 1.5em;margin-bottom: 15px;margin-top: 2rem;">
        作答可信度：<span style="color: #606266;font-weight:normal">{{ kexindu }}</span>
      </p> -->
    </div>

    <!-- <p style="font-size: 2rem;color: #5e6d82;line-height: 1.5em;margin: 2rem 0;">作答真实性</p>
    <el-table :data="faceData" border style="width: 100%;margin-bottom: 15px;">
      <el-table-column type="index" :index="indexMethod" label="题目" width="60">
      </el-table-column>
      <el-table-column prop="faceKey" label="表情">
      </el-table-column>
      <el-table-column prop="time" label="答题时长">
        <template slot-scope="scope">
          {{ scope.row.time }} 秒
        </template>
      </el-table-column>
      <el-table-column prop="zhishixing" label="真实性">
        <template slot-scope="scope">
          <el-tag effect="dark" :type="scope.row.zhishixing === '正常' ? 'primary' : 'info'" size="mini">{{
            scope.row.zhishixing }}</el-tag>
        </template>
      </el-table-column>
    </el-table> -->
    <!-- <div style="align-self: flex-start;">
      <p class="tag-group__title" style="line-height: 1.5em;margin-bottom: 15px;margin-top: 2rem; color: crimson;">
        声明：基于人心理特征的复杂性，以及心理测评本身信效度的局限性，本测评结果只可作为近期心理健康水平的参考，不可作为相关疾病（心理问题）的诊断标准，如有进一步需求或疑问请联系专业机构人员。
      </p>
    </div> -->
    <!-- <el-descriptions class="margin-top" :column="2" border style="width: 80%;">
      <el-descriptions-item label="量表作答结果">
        <span class="color-square" ref="res"></span>
      </el-descriptions-item>
      <el-descriptions-item label="量表作答结果">
        <span class="color-square" ref="res"></span>
      </el-descriptions-item>
    </el-descriptions>
    <div class="tag-group margin-top">
      <span class="tag-group__title">参照</span>
      <el-tag color="#ECF5FF" style="color: rgb(0, 0, 0);border-color:#ECF5FF" size="mini">没有</el-tag>
      <el-tag color="#2ed573" style="color: rgb(0, 0, 0);border-color:#2ed573" size="mini">轻度</el-tag>
      <el-tag color="#eccc68" style="color: rgb(0, 0, 0);border-color:#eccc68" size="mini">中度</el-tag>
      <el-tag color="#ff7f50" style="color: rgb(0, 0, 0);border-color:#ff7f50" size="mini">中重</el-tag>
      <el-tag color="#ff4757" style="color: rgb(0, 0, 0);border-color:#ff4757" size="mini">严重</el-tag>
    </div>
    <el-descriptions class="margin-top" :column="1" border style="width: 80%;" title="作答真实性">
      <el-descriptions-item :label="`第${index + 1}题真实性`" v-for="(item, index) in subjects">
        <span class="color-square" :class="item.res"></span>
      </el-descriptions-item>
    </el-descriptions>
    <div class="tag-group margin-top margin-bot">
      <span class="tag-group__title">参照</span>
      <el-tag color="#2ed573" style="color: rgb(0, 0, 0);border-color:#2ed573" size="mini">真实</el-tag>
      <el-tag color="#ff4757" style="color: rgb(0, 0, 0);border-color:#ff4757" size="mini">欺骗</el-tag>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "Score",
  data() {
    return {
      show: false,
      fullscreenLoading: true,
      cs: [],
      sj_id: 0,
      subjects: [],
      tableData: [],
      faceData: [],
      jianyi: '',
      title: '',
      kexindu: 0,
      useTimeCn: '',
      maxRes: '',
    }
  },
  created() {
    var that = this;
    var sj_id = that.$route.params.sj_id;
    that.sj_id = sj_id;
  },
  methods: {
    fetchData() {
      const data = this.title;
      this.$emit('update-title', data);
    },
    backToHome() {
      this.$store.commit('resetStore');
      this.$router.push('/')
    },
    setData() {
      this.subjects = [];
      this.cs.forEach(res => {
        this.subjects.push({
          res
        })
      })

    },
    startLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "计算结果中...",
        // spinner: "el-icon-loading",
        // background: "rgba(0, 0, 0, 0.2)", //调节透明度
      });
    },
    endLoading() {
      this.loading.close();
    },
    cellClassName({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 2) {
        return this.tableData[rowIndex]['leixing']
      }
    },
    indexMethod(index) {
      return index + 1;
    }
  },
  mounted() {
    // var that = this;
    // that.startLoading();
    // that.$http({
    //   method: 'post',
    //   url: 'https://xl.880802.club/index/test_getRes_69',
    //   headers: {
    //     'Content-Type': 'multipart/form-data'
    //   },
    //   data: {
    //     sj_id: that.sj_id,
    //     uid: that.$store.state.uid
    //   }
    // }).then((res) => {
    //   // console.log(res.data);
    //   // that.$refs.res.className = `color-square ${res.data.res}`;
    //   that.cs = res.data.cs;

    //   that.setData();
    //   that.tableData = res.data.leixing;
    //   that.faceData = res.data.cs;
    //   that.jianyi = res.data.jianyi;
    //   that.title = '小学生心理健康多模态情绪综合测评量表(MQ61)';
    //   // console.log(that.subjects);
    //   that.kexindu = res.data.kexindu + '%';
    //   that.useTimeCn = res.data.useTimeCn;
    //   that.maxRes = res.data.maxRes;
    //   that.show = true;
    //   that.fetchData();
    //   that.endLoading();
    // }).catch((error) => {
    //   console.log(error);
    // });

  }
}
</script>

<style scoped>
.score-container {
  /* text-align: center; */
  display: flex;
  flex-direction: column;
  align-items: center;
}

.score-show {
  display: flex;
  align-items: center;
}

.image-area {
  height: 20rem;
}

.image-area img {
  height: 80%;
}

.score-show {
  font-size: 2rem;
  margin: 2rem 0;
  /* display: flex;
  align-items: center; */
}

.red {
  background-color: #ff4757;
}

.orange {
  background-color: #ff7f50;
}

.yellow {
  background-color: #eccc68;
}

.green {
  background-color: #2ed573;
}

.wu {
  background-color: #ECF5FF;
}

.color-square {
  display: inline-block;
  width: 4rem;
  height: 2rem;
  /* background-color: #ff0000; */
  /* Replace with your desired color */
  margin-left: 5px;
  /* Adjust the spacing as needed */
}

.margin-top {
  margin-top: 20px;
}

.margin-bot {
  margin-bottom: 20px;

}

.tag-group__title {
  margin-right: 10px;
  font-size: 14px;
  color: #909399;
  font-weight: bold;
}

.tag-group {
  display: flex;
  align-items: center;
}

.el-tag+.el-tag {
  margin-left: 10px
}

:deep(.el-table__row .yellow) {
  color: #fff;
  border-color: #eccc68;
}

:deep(.el-table__row .green) {
  color: #fff;
  border-color: #2ed573;
}

:deep(.el-table__row .red) {
  color: #fff;
  border-color: #ff4757;
}

:deep(.el-table__row .orange) {
  color: #fff;
  border-color: #ff7f50;
}

:deep(.el-table__row .wu) {
  color: rgb(0, 0, 0);
  border-color: #ECF5FF;
}
</style>